export default {
      id: "action-icon-changes-approved-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-changes-approved",
      toString: function () {
        return this.url;
      }
    }